import { IItem } from '../../../../../../../shared/analytics/e-commerce/models/IItem';
import { IParkingProduct } from '../../../../../../domain/parking-product/models/IParkingProduct';

export function adaptParkingProductToItem(
	parkingProduct: IParkingProduct,
	promoCode?: string,
): IItem {
	return {
		id: parkingProduct.id.toString(),
		name: parkingProduct.name,
		category: 'Parking',
		price: parkingProduct.price.value,
		coupon: promoCode,
	};
}
